module.exports = __webpack_public_path__ + "static/img/3.5a00bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/7/3.png
// module id = +7no
// module chunks = 2